module.exports = __webpack_public_path__ + "media/images/weather/53_day-6a6f7a9c418faa5d5cef43bb7cdabb9d.png";